import { Typography, type TypographyProps, Stack, Box, type BoxProps } from '@mui/material'
import { SectionItem, type SectionItemProps } from 'settle-ui/components/SectionItem/SectionItem'
import { mergeSx } from 'lib/helpers/mergeSx/mergeSx'

interface SectionProps extends BoxProps {
  title?: string
  subtitle?: TypographyProps['children']
  rightSideContent?: React.ReactNode
  slots?: {
    rightSide?: React.ReactNode
  }
  slotProps?: {
    header?: SectionItemProps
  }
  fullWidth?: boolean
}

export const Section: Settle.FC<SectionProps> = ({
  title,
  subtitle,
  rightSideContent,
  slots,
  slotProps,
  children,
  sx,
  fullWidth,
  ...props
}) => (
  <Box py={1} {...props} sx={mergeSx({ width: fullWidth ? '100%' : 'auto' }, sx)}>
    {Boolean(title || subtitle || slots?.rightSide) && (
      <SectionItem fullWidth={fullWidth} verticalGutter="none" {...slotProps?.header}>
        {(title || slots?.rightSide) && (
          <Stack direction="row" justifyContent={title ? 'space-between' : 'flex-end'} alignItems="center" pb={1}>
            {title && <Typography variant="subtitle1">{title}</Typography>}
            {slots?.rightSide}
          </Stack>
        )}
        {subtitle && (
          <Typography variant="body2" color="onSurfaceSecondary" pb={1}>
            {subtitle}
          </Typography>
        )}
      </SectionItem>
    )}
    <Box>{children}</Box>
  </Box>
)
